import api from '@/lib/api';
import { toast } from 'sonner';

// Certificates are private: fetch them with the session (and its refresh) instead of linking.
export async function openCertificate(url, downloadName) {
  if (!url) return;
  const path = url.replace(/^https?:\/\/[^/]+/, '').replace(/^\/api/, '');
  try {
    const { data } = await api.get(path, { responseType: 'blob' });
    const blobUrl = window.URL.createObjectURL(data);
    if (downloadName) {
      const a = document.createElement('a');
      a.href = blobUrl;
      a.download = downloadName;
      document.body.appendChild(a);
      a.click();
      a.remove();
    } else {
      window.open(blobUrl, '_blank', 'noopener');
    }
    setTimeout(() => window.URL.revokeObjectURL(blobUrl), 60000);
  } catch (e) {
    toast.error(e.response?.status === 403
      ? 'This certificate is not available to your account'
      : 'Certificate file not available. Please contact support.');
  }
}
